import React from 'react';
import { useNavigate } from 'react-router-dom';

const FormActionsFooter = ({ isSubmitting, cancelPath = '/admin/products' }) => {
  const navigate = useNavigate();
  
  return (
    <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-end">
      <button
        type="button"
        onClick={() => navigate(cancelPath)}
        className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540] mr-3"
      >
        Annuler
      </button>
      <button
        type="submit"
        disabled={isSubmitting}
        className="inline-flex items-center justify-center py-2 px-6 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#174540] hover:bg-[#0d2926] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540] disabled:bg-gray-400 disabled:cursor-not-allowed"
      >
        {isSubmitting ? (
          <>
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Mise à jour en cours...
          </>
        ) : 'Mettre à jour le produit'}
      </button>
    </div>
  );
};

export default FormActionsFooter;